import { queryOptions } from "@tanstack/react-query";

import { getCoachAvailability } from "../services/getCoachAvailability";
import { CoachAvailabilityRequest } from "../types/CoachAvailabilityRequest";
import { emptyOnRejectedRange } from "../utils/emptyOnRejectedRange";

const getCoachAvailabilityKeys = {
  root: ["getCoachAvailability"] as const,
  byCoachIdAndInterval: (data: CoachAvailabilityRequest) =>
    [
      ...getCoachAvailabilityKeys.root,
      "coachAvailability",
      data.coachId,
      data.startDate,
      data.endDate,
    ] as const,
};

export const getCoachAvailabilityQuery = (data: CoachAvailabilityRequest) =>
  queryOptions({
    queryKey: getCoachAvailabilityKeys.byCoachIdAndInterval(data),
    queryFn: () => emptyOnRejectedRange(() => getCoachAvailability(data)),
    enabled: Boolean(data.coachId),
    retry: false,
    refetchOnWindowFocus: (query) =>
      query.state.status !== "error" || query.state.data !== undefined,
    retryOnMount: false,
  });
